import React from 'react';



import classes from './ProofNumbers.module.scss';

const ProofNumbers = () => {
    return (
        <div className={classes.wrapper}>
            <div className='container'>
                <div className='row'>
                    <div className="col-lg-4 col-12 d-flex justify-content-center align-items-center">
                        <h3>
                            Proof in Numbers
                        </h3>
                    </div>
                    <div className="col-lg-4 col-12 text-lg-start text-center">
                        <span>70K+</span>
                        <h5>Users</h5>
                        <p>From 152 countries worldwide</p>
                        <span>800+</span>
                        <h5>Pharma jobs</h5>
                        <p>Analyzed for content: Curricula built from real vacancies</p>
                    </div>
                    <div className="col-lg-4 col-12 text-lg-start text-center">
                        <span>96%</span>
                        <h5>Satisfaction</h5>
                        <p>From users in surveys since 2023</p>
                        <span>350+</span>
                        <h5>Certificates</h5>
                        <p>Posted on LinkedIn by our users each month</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProofNumbers;